import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { blue, green } from "@mui/material/colors";
import { ICellRendererParams } from "ag-grid-community";

import { ExtendedPermission } from "fond/types";
import { isNew } from "fond/utils/permissions";

const TypeCellRenderer: React.FC<ICellRendererParams<ExtendedPermission, boolean>> = ({ value: isGuest, data: permission }) => {
  if (isGuest && permission) {
    const guestChip = (
      <Chip data-testid="guest-chip" label="Guest" size="small" variant="outlined" style={{ color: blue[500], borderColor: blue[500] }} />
    );
    if (!isNew(permission)) {
      return <Tooltip title="This user is not part of this account and cannot be granted permissions higher than collaborator">{guestChip}</Tooltip>;
    }
    return guestChip;
  }

  return <Chip data-testid="member-chip" label="Member" size="small" variant="outlined" style={{ color: green[500], borderColor: green[500] }} />;
};

export default TypeCellRenderer;
